<template>
	<div class="main-layout">
		<dashboard-header></dashboard-header>
		<div id="dashboard-wrapper">
			<dashboard-sidebar></dashboard-sidebar>
			<div id="dashboard-content">
				<child />
			</div>
		</div>
	</div>
</template>

<script>
import DashboardHeader from "~/components/DashboardHeader";
import DashboardSidebar from "~/components/DashboardSidebar";

export default {
	name: "BasicLayout",

	components: {
		DashboardHeader,
		DashboardSidebar
	}
};
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/layouts/dashboard.vue